// Lets non-component modules (axios interceptors) navigate via React Router
// instead of assigning window.location.
//
// window.location.href = '/portal/login' is a FULL DOCUMENT LOAD. On 2026-07-27 that
// turned a soft-navigable SPA route into a hard request that nginx answered with a
// 404, and a client spent days unable to reach the code-entry screen. A soft
// navigation cannot be intercepted by host routing, so it cannot fail that way.

let _navigate = null;

export function setNavigator(navigate) {
  _navigate = navigate;
}

// Routes that ARE the login surface. Redirecting to the login page from the login
// page is what destroyed the code-entry screen: it mounts, its own pre-auth call
// 401s, and the interceptor bounces the browser off the page the user is looking at.
const LOGIN_ROUTES = [
  '/login',
  '/portal/login',
  '/portal/forgot-password',
  '/portal/reset-password',
  '/forgot-password',
  '/reset-password',
];

export function isOnLoginRoute(pathname = window.location.pathname) {
  return LOGIN_ROUTES.some((r) => pathname === r || pathname.startsWith(r + '?'));
}

export function goToLogin(target = '/portal/login') {
  if (isOnLoginRoute()) return; // already here — never bounce
  if (_navigate) {
    _navigate(target, { replace: true });
  } else {
    // Router not mounted yet (e.g. a 401 during initial bootstrap). A hard load is
    // the only option left, but it is the fallback, not the default.
    window.location.replace(target);
  }
}
